import React from 'react';

import { useNavigate } from 'react-router-dom';
// export default Footer;
// Footer.jsx
export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="bg-[#0F1B30] text-white py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-7 divide-x divide-gray-700">
            <div className="px-2 py-2 flex flex-col text-left"> 
              <h5 className="text-lg text-left pb-2">Monday</h5>
              <p>8:00am - 5:00pm</p>
            </div>
            <div className="px-2 py-2 flex flex-col text-left"> 
              <h5 className="text-lg text-left pb-2">Tuesday</h5>
              <p>8:00am - 5:00pm</p>
            </div>
            <div className="px-2 py-2 flex flex-col text-left"> 
              <h5 className="text-lg text-left pb-2">Wednesday</h5>
              <p>8:00am - 5:00pm</p>
            </div>
            <div className="px-2 py-2 flex flex-col text-left"> 
              <h5 className="text-lg text-left pb-2">Thursday</h5>
              <p>8:00am - 5:00pm</p>
            </div>
            <div className="px-2 py-2 flex flex-col text-left"> 
              <h5 className="text-lg text-left pb-2">Friday</h5>
              <p>8:00am - 5:00pm</p>
            </div>
            <div className="px-2 py-2 flex flex-col text-left"> 
              <h5 className="text-lg text-left pb-2">Satuday</h5>
              <p>9:00am - 12:00pm</p>
            </div>
            <div className="px-2 py-2 flex flex-col text-left"> 
              <h5 className="text-lg pb-2">Sunday</h5>
              <p>Closed</p>
            </div>
          
        
        </div>
        
        <div className="mt-6">
  <address className="pr-10 not-italic">
    <ul className="mx-auto max-w-3xl flex flex-col items-center gap-1 text-sm text-white/80 sm:flex-row sm:justify-center sm:divide-x sm:divide-gray-300">
      <li className="px-3 text-center">
        <span className="font-semibold">Central Illinois Pediatric Associates</span>
      </li>
      <li className="font-semibold px-3 text-center">
      <a
  href={`https://www.google.com/maps/search/?api=1&query=Central%20Illinois%20Pediatric%20Associates&query_place_id=YOUR_PLACE_ID`}
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-custom-regularOrange"
>
  2427 Maloney Dr, Bloomington, IL 61704
</a>

      </li>
      <li className="font-semibold px-3 text-center">
        <a href="tel:+13096631011" className="hover:text-custom-regularOrange">
          (309) 663-1011
        </a>
      </li>
    </ul>
  </address>
</div>


        {/* <div className="flex justify-center mt-4 md:mt-0 text-center">
            
            <a href="#" className="mx-2">G+</a> 
            <a href="#" className="mx-2">FB</a>
            <a href="#" className="mx-2">RSS</a>
            <a href="#" className="mx-2">TW</a>
        </div> */}
        
        <div className="text-center mt-4 border-t border-gray-700 pt-4">
          <p>COPYRIGHT © 2024</p>
          {/* Footer links */}
          <div className="flex justify-center space-x-4">
            {/* <a onClick={() => navigate('/AdminLogin')} className="text-gray-400 hover:text-gray-300">Admin Log In</a> */}
            {/* <a href="#" className="text-gray-400 hover:text-gray-300">Site Map</a> */}
            <a href="#" className="text-gray-400 hover:text-gray-300">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-gray-300">HIPAA Policy</a>
            {/* <a href="#" className="text-gray-400 hover:text-gray-300">Terms of Use</a> */}
            <a href="#" className="text-gray-400 hover:text-gray-300">Employment Application</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
